import { Link } from 'react-router-dom';
import sc from '../styled';
import { bigButton } from './landingPage.css';

export const BigButton = sc(Link)(bigButton);
